import { createFileRoute } from '@tanstack/react-router';

import { WorkshopScreen } from '../../features/personal/WorkshopScreen';

/** `/personal/workshop` = ورشة الكتابة (خطة القسم الشخصي ش12، الشريحة الرقيقة). */
export const Route = createFileRoute('/personal/workshop')({ component: WorkshopScreen });
